module.exports={render:function (){var _vm=this;
  return _vm._h('div', {
    staticClass: "container",
    attrs: {
      "id": "blog"
    }
  }, [_vm._h('router-view')])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-ddd229e2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Blog.vue
// module id = 71
// module chunks = 1